import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatRipple } from '@angular/material/core';
import { WhatsnewData } from './version-check.service';

@Component({
  selector: 'app-whatsnew-dialog',
  templateUrl: './whatsnew-dialog.component.html',
  standalone: true,
  imports: [MatIcon, MatRipple],
  styles: [`
    :host { display: block; overflow: hidden; border-radius: 1.25rem; }
  `],
})
export class WhatsnewDialogComponent {
  public readonly data: WhatsnewData;
  public readonly formattedDate: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: WhatsnewData,
    private readonly dialogRef: MatDialogRef<WhatsnewDialogComponent>,
  ) {
    this.data = data;
    this.formattedDate = new Date(data.date).toLocaleDateString('en-GB', {
      day: 'numeric', month: 'long', year: 'numeric',
    });
  }

  public close(): void {
    this.dialogRef.close();
  }
}
